module.exports = __webpack_public_path__ + "img/case-ct_compactsnipers_full.e18ad09.png";